if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


function getAccommodations(container, selectVal){
    
    fetch(`${site_url}ajax/functions.php?operation=getSiteAcommodations&siteId=`+siteId+`&tag=`+selectVal,{method: "GET"}) 
    .then((resp) => resp.json()) // Transform the data into json
    .then((data) => {
        container.innerHTML = data.html; //set data response via fetch in the container
        $('.room__images').slick({
            accessibility: true,
            fade: true
        });
    });
}


function getTagCols(container,selectVal,blog_id){
    console.log(selectVal);
    container.classList.remove('active');
    setTimeout(function(){
        fetch(`${site_url}ajax/functions.php?operation=getCarouselItems&blog_id=`+blog_id+`&tag=`+selectVal,{method: "GET"}) 
        .then((resp) => resp.json()) // Transform the data into json
        .then((data) => {
            if(container.classList.contains('slick-slider')){
                $(container).slick('unslick');
            }
            container.innerHTML = data.html; //set data response via fetch in the container
            setTimeout(function(){
                $(container).slick({
                    accessibility: false
                });
                container.classList.add('active');
            },0)
            
            const btn = document.getElementsByClassName('btn');
            if(btn){
                for(let b = 0; b < btn.length; b++){
                    const this_html = btn[b].innerHTML;
                    //btn[b].dataset.title = this_html;
                }
            }
        });
    },250)
    
}


(function(){

    const rooms_container = document.getElementById('js-accommodations-content');
    const roomsNav = document.querySelectorAll('.accommodations__nav a');
    if(rooms_container){
        for(let i = 0; i < roomsNav.length; i++){
            roomsNav[i].addEventListener('click', function(){
                const thisTag = this.dataset.tag;
                console.log(thisTag);
                getAccommodations(rooms_container, thisTag);
                for(let m = 0; m < roomsNav.length; m++){
                    roomsNav[m].classList.remove('active');
                }
                this.classList.add('active');

            });
        }

        getAccommodations(rooms_container, '');
    }

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    

    const columns_slider = document.getElementById('js-columns-tags-content');
    const columnsNav = document.querySelectorAll('.columns-carousel__nav a');
    if(columns_slider){
        const slider_id = columns_slider.dataset.id;

        for(let c = 0; c < columnsNav.length; c++){
            columnsNav[c].addEventListener('click', function(){
                const thisTag = this.dataset.tag;
                let this_text = this.innerHTML.toLowerCase();
                // document.querySelector('.columns-carousel--tags h2 strong').innerHTML = this_text+' in';
                //separateScript();
                // console.log(this_text);
                getTagCols(columns_slider,thisTag,slider_id);
                for(let m = 0; m < columnsNav.length; m++){
                    columnsNav[m].classList.remove('active');
                }
                this.classList.add('active');
            });
        }


        getTagCols(columns_slider,'',slider_id);
    }


    $('.sym-slides').slick({
        accessibility: false
    });

    let openMenu = document.getElementById('js-open-menu');
    if(openMenu){
        let closeMenu = document.getElementById('js-close-menu');
        openMenu.addEventListener('click', function(){
            $('#menu-slide').addClass('show');
        });

        closeMenu.addEventListener('click', function(){
            $('#menu-slide').removeClass('show');
        });
    }

    let openmenuM = document.getElementById('js-open-menu-mobile');
    if(openmenuM){
        let closeMenu = document.getElementById('js-close-menu');
        openmenuM.addEventListener('click', function(){
            $('#menu-slide').addClass('show');
        });

        closeMenu.addEventListener('click', function(){
            $('#menu-slide').removeClass('show');
        });
    }

    let openHotels = document.getElementById('js-open-hotels');
    if(openHotels){
        let closeHotels = document.getElementById('js-close-hotels');
        openHotels.addEventListener('click', function(){
            $('#hotels-mobile').addClass('show');
        });

        closeHotels.addEventListener('click', function(){
            $('#hotels-mobile').removeClass('show');
        });
    }
    

    // $('.columns__row').slick({
    //     arrows: true,
    //     dots: false,
    //     infinite: true,
    //     autoplay: true,
    //     autoplaySpeed: 7000,
    //     speed: 700,
    //     slidesToShow: 1,
    //             slidesToScroll: 1,
    //     mobileFirst: true,
    //     responsive: [
    //         {
    //           breakpoint: 600,
    //           settings: "unslick"
    //         },
    //         {
    //           breakpoint: 575,
    //           settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1
    //           }
    //         }
    //         // You can unslick at a given breakpoint now by adding:
    //         // settings: "unslick"
    //         // instead of a settings object
    //       ]
    // });
    // $(window).on('resize orientationchange', function() {
    //     $('.columns__row').slick('resize');
    // });

    $('.columns2__row').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 700,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
    });

    $('.other-specials-slider').slick({
        arrows:true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 500,
        fade: false,
        accessibility: true,
        pauseOnHover: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2 ,
                }
            },
            {
                breakpoint: 600,
                settings: "unslick"
            },
        ]
    });

    $('.columns-carousel__slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1030,
                settings: {
                    slidesToShow: 2 ,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });

    $('.fancybox').fancybox({
        touch:{
            vertical: false
        }
    });


    const filter_select = document.getElementById('js-press-img-select');
    if(filter_select){
        filter_select.addEventListener('change', function(){
            const this_val = this.value;
            const text_groups = document.querySelectorAll('.press-and-images__item');
            for(let g = 0; g <text_groups.length; g++){
                if(text_groups[g].getAttribute( "data-tag" ) == this_val){
                    text_groups[g].classList.add('active');
                }else{
                    text_groups[g].classList.remove('active');
                }
            }
            const images_groups = document.querySelectorAll('.press-and-images__group');
            for(let g = 0; g <images_groups.length; g++){
                images_groups[g].classList.remove('active');
            }
            document.querySelector(`.press-and-images__group[data-tag="${this_val}"]`).classList.add('active');
        })
    }

    if ($(window).width() <= 575){
        if($('.columns-carousel__nav').length > 0){
            const filter_tab_carousel = document.querySelectorAll('.columns-carousel__nav ul li a');
            filter_tab_carousel[0].click();
        }
    }

    // Selecciona todos los elementos .menu-slider__item
    const menuItems = document.querySelectorAll('.menu-slider__item');

    menuItems.forEach(menuItem => {
        // Selecciona todos los <li> dentro del <ul> con la clase .tabs
        const tabs = menuItem.querySelectorAll('.tabs li');
        const menuBlocks = menuItem.querySelectorAll('.menu-block');
        const select = menuItem.querySelector('.tabs-select');

        const activateTab = (menuId) => {
            tabs.forEach(t => t.classList.remove('active'));
            menuBlocks.forEach(block => block.classList.remove('active'));

            const activeTab = menuItem.querySelector(`.tabs li[data-menu="${menuId}"]`);
            if (activeTab) activeTab.classList.add('active');

            const activeBlock = menuItem.querySelector(`.menu-block[data-menu="${menuId}"]`);
            if (activeBlock) activeBlock.classList.add('active');
        };

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const menuId = tab.getAttribute('data-menu');
                activateTab(menuId);
            });
        });

        if (select) {
            select.addEventListener('change', () => {
                const menuId = select.value;
                activateTab(menuId);
            });

            if (select.options.length > 0) {
                select.value = select.options[0].value;
                select.dispatchEvent(new Event('change'));
            }
        }

        if (tabs.length > 0) {
            tabs[0].click();
        }
    });

    const symSlides = document.querySelector('.sym-slides');

    if (symSlides) {
        const updateHeight = () => {
            const activeItem = symSlides.querySelector('.menu-slider__item.slick-active');
            if (activeItem) {
                const activeHeight = activeItem.offsetHeight;
                symSlides.style.height = `${activeHeight}px`;
            }
        };

        // Actualiza el height al cargar la página
        updateHeight();

        // Escucha el evento de cambio de slide de Slick
        symSlides.addEventListener('afterChange', updateHeight);

        // Si Slick no emite eventos directamente en el contenedor, usa un intervalo para monitorear cambios
        setInterval(updateHeight, 100);
    }
})();